<template>
    <div class="md-layout md-gutter">
        <div class="md-layout-item md-size-66">
            <form ref="devices_products_edit" @submit.prevent="updateDevicesProducts">
                <md-card>
                    <md-card-header class="md-card-header-icon md-card-header-blue">
                        <div class="md-layout">
                            <div class="md-layout-item">
                                <div class="card-icon">
                                    <font-awesome-icon class="md-icon" :icon="['fa', 'file-alt']" />
                                </div>
                                <h4 class="title">Gestion des produits de dispositifs</h4>
                            </div>
                        </div>
                    </md-card-header>
                    <md-card-content>
                        <template v-if="devices.length > 0">
                            <device-product-row v-for="(device, index) in devices" :key="device.id" :index="index"
                                :device="device" :products="products" :errors="errors" @deleted="getDevices"></device-product-row>
                        </template>
                        <p v-else>Aucun dispositif nécessitant un produit sur ce site</p>
                    </md-card-content>
                    <md-card-actions md-alignment="left">
                        <md-button type="submit" class="md-success">
                            Enregistrer
                        </md-button>
                        <md-button class="md-warning"
                                   @click="goBack">
                            Retour
                        </md-button>
                    </md-card-actions>
                </md-card>
            </form>
        </div>
    </div>
</template>

<script>
// Components
import DeviceProductRow from "@/pages/Sites/Devices/Products/DeviceProductRow";

export default {
    name: "DevicesProductsEdit",
    components: {
        DeviceProductRow
    },
    data() {
        return {
            devices: [],
            products: [],
            errors: []
        }
    },
    methods: {
        async getDevices() {
            const { data } = await this.$store.dispatch('devices/getDevicesNeedProducts', {
                siteId: this.$route.params.idSite
            })
            this.devices = data
        },
        async getProducts() {
            const { data } = await this.$store.dispatch('products/getAllProducts')
            this.products = data
        },
        async updateDevicesProducts() {
            this.errors = []
            try {
                await this.$store.dispatch('sites/updateDevicesProducts', {
                    siteId: this.$route.params.idSite,
                    devices: this.devices
                })
                await this.$store.dispatch('alerts/success', 'Dispositifs modifiés')
            } catch (e) {
                this.errors = e.response.data.errors
            }
        },
        goBack() {
            this.$router.back()
        }
    },
    mounted() {
        this.getDevices()
        this.getProducts()
    }
}
</script>

<style scoped>

</style>
